import { render, staticRenderFns } from "./portfolio-private.vue?vue&type=template&id=be7d0c74&"
import script from "./portfolio-private.vue?vue&type=script&lang=js&"
export * from "./portfolio-private.vue?vue&type=script&lang=js&"
import style0 from "./portfolio-private.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/php7/nickyeconomou.com/public/site/nickyeconomou/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be7d0c74')) {
      api.createRecord('be7d0c74', component.options)
    } else {
      api.reload('be7d0c74', component.options)
    }
    module.hot.accept("./portfolio-private.vue?vue&type=template&id=be7d0c74&", function () {
      api.rerender('be7d0c74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/pages/portfolio-private.vue"
export default component.exports